import React from 'react';
import { Banner } from '../../../../models';
import CloseButton from './CloseButton';
import styles from '../StaticBanner.module.scss';

type Props = {
    banner: Banner;
    onClick: () => void;
    onClose: () => void;
    previewMode?: boolean;
}

const ImageLinkBanner: React.FC<Props> = ({ banner, onClick, onClose, previewMode }) => {
    return (
        <div className={styles.bannerImage}>
            <div
                onClick={onClick}
                className={styles.imageLink}
                style={previewMode ? { cursor: 'default' } : undefined}
            >
                <img
                    src={banner.imageUrl!}
                    alt={banner.title || ''}
                    title={banner.title || ''}
                    className={styles.image}
                />
            </div>
            {banner.staticHideable && (
                <CloseButton onClick={onClose} />
            )}
        </div>
    );
};

export default ImageLinkBanner;
